"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractStringifiedEditorStateAnswerFromMultipleChoiceProblem = exports.QuestionLanguage = exports.generateNewMultipleChoiceOptionId = void 0;
const nanoid_1 = require("nanoid");
const assert_1 = __importDefault(require("assert"));
const generateNewMultipleChoiceOptionId = () => (0, nanoid_1.nanoid)(5);
exports.generateNewMultipleChoiceOptionId = generateNewMultipleChoiceOptionId;
var QuestionLanguage;
(function (QuestionLanguage) {
    QuestionLanguage["calculate"] = "calculate";
    QuestionLanguage["describe"] = "describe";
    QuestionLanguage["recommend"] = "recommend";
    QuestionLanguage["compare"] = "compare";
    QuestionLanguage["list"] = "list";
    QuestionLanguage["critique"] = "critique";
    QuestionLanguage["create"] = "create";
    QuestionLanguage["assess"] = "assess";
    QuestionLanguage["define"] = "define";
    QuestionLanguage["multiPart"] = "multiPart";
})(QuestionLanguage || (exports.QuestionLanguage = QuestionLanguage = {}));
const extractStringifiedEditorStateAnswerFromMultipleChoiceProblem = (multipleChoiceProblem) => {
    var _a;
    const choiceID = multipleChoiceProblem.solution;
    const answer = (_a = multipleChoiceProblem.choices.find((choice) => choice.id === choiceID)) === null || _a === void 0 ? void 0 : _a.stringifiedMagicTextBox;
    (0, assert_1.default)(answer);
    return answer;
};
exports.extractStringifiedEditorStateAnswerFromMultipleChoiceProblem = extractStringifiedEditorStateAnswerFromMultipleChoiceProblem;
//# sourceMappingURL=types.js.map